// extracted by mini-css-extract-plugin
module.exports = {"sharableLinkWrapper":"SharableLink_sharableLinkWrapper__ncSMd","sharableLinkContainer":"SharableLink_sharableLinkContainer__YDtFo","sharableBtn":"SharableLink_sharableBtn__KtHEc"};